module.exports = [[module.id, "", '', {"version":3,"sources":[],"names":[],"mappings":"","sourceRoot":""}]]